import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import type { DictionaryEntry } from '../types'

interface UseEntryResult {
  entry: DictionaryEntry | null
  loading: boolean
  error: string | null
}

export function useEntry(entryId: string | undefined): UseEntryResult {
  const [entry, setEntry]     = useState<DictionaryEntry | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState<string | null>(null)

  useEffect(() => {
    if (!entryId) return
    let cancelled = false

    const run = async () => {
      setLoading(true)
      setError(null)
      setEntry(null)

      const { data, error: err } = await supabase
        .from('dictionary_entries')
        .select('*')
        .eq('entry_id', entryId)
        .single()

      if (cancelled) return
      if (err) {
        setError(err.message)
      } else {
        setEntry(data as DictionaryEntry)
      }
      setLoading(false)
    }

    run()
    return () => { cancelled = true }
  }, [entryId])

  return { entry, loading, error }
}
